import {Component} from 'vue-property-decorator';
import Vue from 'vue';
import {Action, State} from 'vuex-class';
import {
  InformationServiceTransaction, ServiceRead,
  ServiceTransactionInitState,
  ServiceTransactionStatus
} from '@/store/service-transaction/service-transaction.types';
import {MemberInitState} from '@/store/member/member.types';
import {Toast} from '@/store/toast/toast.types';
import moment from 'moment';
import {IdReference} from '@/store/type';
import {TimeUsed} from '@/services/time.service';
import {Helper} from '../../../util/helper';
import {MemberServiceType} from '@/store/member/member.enum';

interface ViewFinal {
  startTime: string;
  timeUsed: string;
  otherMemberDetail: string;
  topic: string;
  moreDetail: string;
  viewType: string[];
  timeLeftNotEnough: boolean;
  amountReceived: string;
}

@Component({
  components: {}
})
export default class PaymentFinalInformationComponent extends Vue {
  @State('serviceTransaction') serviceTransactionInitState!: ServiceTransactionInitState;
  @State('member') memberInitState!: MemberInitState;
  @Action('_Loading', {namespace: 'loading'}) Loading!: (payload: boolean) => Promise<void>;
  @Action('_Toast', {namespace: 'toast'}) Toast!: (payload: Toast) => Promise<void>;
  @Action('_updateRead', {namespace: 'serviceTransaction'}) updateRead!: (payload: string) => Promise<void>;
  @Action('_getFinalInformation', {namespace: 'serviceTransaction'}) getFinalInformation!: (payload: IdReference) => Promise<void>;

  public view: ViewFinal = {
    moreDetail: '',
    otherMemberDetail: '',
    startTime: '',
    timeUsed: '',
    topic: '',
    viewType: ['', ''],
    timeLeftNotEnough: false,
    amountReceived: ''
  };
  public info = {} as InformationServiceTransaction;
  public lib: Helper = new Helper();

  async mounted() {
    this.Loading(true);
    let {id} = this.$route.query;
    if (!id) {
      this.$router.push('/').then();
    }
    await this.getFinalInformation({id} as IdReference);

    this.info = this.serviceTransactionInitState.information;
    if (this.info.read === ServiceRead.Unread) {
      await this.updateRead(id as string);
    }
    if (!this.info.serviceEndDate) {
      this.view.timeUsed = `รอการยืนยันจากผู้ให้บริการ`;
    } else {
      this.view.timeUsed = TimeUsed({
        timeStart: this.info.serviceStartDate,
        timeEnd: this.info.serviceEndDate
      });
      this.view.amountReceived = this.view.timeUsed;

      // เวลาที่ใช้มากกว่าเวลาที่มี
      if (this.info.serviceTransactionStatus !== ServiceTransactionStatus.Done) {
        let minute = moment(this.info.serviceEndDate).diff(this.info.serviceStartDate, 'minute');
        if (parseInt(this.info.pointLeft) < minute) {
          this.view.timeLeftNotEnough = true;
          this.view.amountReceived = this.info.pointLeft + ' นาที';
        }
      }

    }
    this.view.startTime = this.lib.formatDateTimeThai(this.info.serviceStartDate);

    this.view.topic = `${this.info.subService.name} | ${this.view.startTime}`;
    if (this.info.isOwner) {
      this.setOwnerView();
    } else {
      this.setInviteView();
    }

    if (this.info.serviceTransactionStatus === ServiceTransactionStatus.Done) {
      this.view.viewType[2] = 'การชำระเวลา';
      this.view.amountReceived = Math.abs(this.info.timeTransaction[0].point).toString() + ' นาที';
    }

    this.Loading(false);
  }

  async setOwnerView() {
    this.view.viewType = ['สำหรับผู้รับบริการ', 'ผู้รับชำระ', 'จำนวนเวลาที่ต้องชำระ'];
    if(this.info.serviceType === MemberServiceType.ServiceReceiver) {
      this.view.otherMemberDetail = `${this.info.member.firstName} ${this.info.member.lastName}`;
    }else {
      this.view.otherMemberDetail = `${this.info.invite.firstName} ${this.info.invite.lastName}`;
    }
  }

  async setInviteView() {
    this.view.viewType = ['สำหรับผู้ให้บริการ', 'ผู้ชำระ', 'จำนวนเวลาที่ต้องได้รับ'];
    if(this.info.serviceType === MemberServiceType.ServiceReceiver) {
      this.view.otherMemberDetail = `${this.info.invite.firstName} ${this.info.invite.lastName}`;
    }else {
      this.view.otherMemberDetail = `${this.info.member.firstName} ${this.info.member.lastName}`;
    }
  }

  mainMenuClick() {
    this.$router.push('/').then();
  }
}


